//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ProductViewDetail',
  data() {
    return {
      detailList: {}, // 详情列表
      businessAddress: '', // 业务网点
      applyObjectList: [], // 适用对象
      addressList: '', // 地区
    }
  },
  created() {
    this.getSelectOneList()
    this.businessAddress = this.$route.query.businessAddress
  },
  methods: {
    getSelectOneList() {
      let params = {
        id: this.$route.query.id,
      }
      this.$http.insure.getInsureProductDetail(params).then((res) => {
        this.detailList = res.data
        let _detailList = this.detailList
        let _arr = []
        _detailList.applyObject.forEach((item) => {
          if (item == 1) {
            item = '种植户'
          } else if (item == 2) {
            item = '农户'
          } else if (item == 3) {
            item = '服务组织'
          } else if (item == 4) {
            item = '村集体'
          }
          _arr.push(item)
        })
        this.$set(this, 'addressList', _detailList.areaList)
        this.$set(this, 'applyObjectList', _arr)
      })
    },
  },
}
